import React from 'react';

const FormServicio = ({ formDatos, setFormDatos }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Tipo Servicio *</label>
      <select value={formDatos.tipo_servicio || ''} onChange={(e) => setFormDatos(p => ({ ...p, tipo_servicio: e.target.value }))}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-tipo-servicio">
        <option value="">Seleccionar</option>
        <option value="IATF">IATF</option>
        <option value="Monta Natural">Monta Natural</option>
        <option value="IA">IA</option>
      </select>
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Toro / Pajuela</label>
      <input type="text" value={formDatos.toro || ''} onChange={(e) => setFormDatos(p => ({ ...p, toro: e.target.value }))}
        placeholder="Nombre toro..." className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Fecha Servicio</label>
      <input type="date" value={formDatos.fecha_servicio || formDatos.fecha || ''} onChange={(e) => setFormDatos(p => ({ ...p, fecha_servicio: e.target.value }))}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Resultado</label>
      <select value={formDatos.resultado || ''} onChange={(e) => setFormDatos(p => ({ ...p, resultado: e.target.value }))}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-resultado">
        <option value="">Pendiente</option>
        <option value="preñada">Preñada</option>
        <option value="vacia">Vacía</option>
        <option value="absorcion">Absorción</option>
      </select>
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Fecha Confirmacion</label>
      <input type="date" value={formDatos.fecha_confirmacion || ''} onChange={(e) => setFormDatos(p => ({ ...p, fecha_confirmacion: e.target.value }))}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Dias Gestacion</label>
      <input type="number" value={formDatos.dias_gestacion || ''} onChange={(e) => setFormDatos(p => ({ ...p, dias_gestacion: e.target.value }))}
        placeholder="280" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Temporada</label>
      <input type="text" value={formDatos.temporada || ''} onChange={(e) => setFormDatos(p => ({ ...p, temporada: e.target.value }))}
        placeholder="2025-2026" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">GDR (1-4)</label>
      <select value={formDatos.gdr || ''} onChange={(e) => setFormDatos(p => ({ ...p, gdr: e.target.value }))}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-gdr">
        <option value="">--</option>
        <option value="1">1 - Inmadura</option>
        <option value="2">2 - Pre-puberal</option>
        <option value="3">3 - Puberal (apta IATF)</option>
        <option value="4">4 - Madura (apta IATF)</option>
      </select>
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Observaciones</label>
      <input type="text" value={formDatos.observaciones || ''} onChange={(e) => setFormDatos(p => ({ ...p, observaciones: e.target.value }))}
        placeholder="Notas..." className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
  </div>
);

export default FormServicio;